// Mock data for Mahindra Susten clone

export const NAV_ITEMS = [
  {
    label: 'DISCOVER',
    children: [
      { label: 'Discover Susten', href: '#discover' },
      { label: 'Leadership Team', href: '#leadership' },
      { label: 'Milestones', href: '#milestones' },
      { label: 'Awards & Recognition', href: '#awards' },
    ],
  },
  {
    label: 'VALUE CHAIN',
    children: [
      { label: 'Utility Scale Solar', href: '#utility' },
      { label: 'Wind Energy', href: '#wind' },
      { label: 'Hybrid & BESS', href: '#hybrid' },
      { label: 'Rooftop Solar', href: '#rooftop' },
      { label: 'Projects', href: '#projects' },
    ],
  },
  {
    label: 'ESG',
    children: [
      { label: 'Environment', href: '#environment' },
      { label: 'Social', href: '#social' },
      { label: 'Governance', href: '#governance' },
      { label: 'Sustainability Report', href: '#report' },
    ],
  },
  {
    label: 'CULTURE',
    children: [
      { label: 'Life at Susten', href: '#life' },
      { label: 'Careers', href: '#careers' },
      { label: 'Diversity & Inclusion', href: '#diversity' },
    ],
  },
  {
    label: 'INVESTORS',
    children: [
      { label: 'Financials', href: '#financials' },
      { label: 'Announcements', href: '#announcements' },
      { label: 'Corporate Governance', href: '#corp-gov' },
    ],
  },
];

export const STATS = [
  { value: '1.5', suffix: 'GWp+', label: 'Developed portfolio' },
  { value: '3.1', suffix: 'GWp+', label: 'Under development' },
  { value: '15+', suffix: 'Years', label: 'Powering India' },
  { value: '50M+', suffix: 'Tonnes', label: 'CO\u2082 offset' },
];

export const PROJECT_LOCATIONS = [
  { id: 1, name: 'Goyalri Project', state: 'Rajasthan', top: '32%', left: '28%' },
  { id: 2, name: 'ISTS-1', state: 'Rajasthan', top: '38%', left: '25%' },
  { id: 3, name: 'ISTS-2', state: 'Bikaner', top: '28%', left: '30%' },
  { id: 4, name: 'Astra Charanka', state: 'Gujarat', top: '48%', left: '22%' },
  { id: 5, name: 'GUVNL', state: 'Gujarat', top: '52%', left: '25%' },
  { id: 6, name: 'SECI', state: 'Rajasthan', top: '35%', left: '32%' },
  { id: 7, name: 'Rewa', state: 'Madhya Pradesh', top: '52%', left: '45%' },
  { id: 8, name: 'Neo Solren', state: 'Telangana', top: '68%', left: '48%' },
  { id: 9, name: 'Brightsolar', state: 'Andhra Pradesh', top: '75%', left: '52%' },
  { id: 10, name: 'RUVNL', state: 'Rajasthan', top: '40%', left: '30%' },
];

export const HAPPENING_NEWS = [
  {
    id: 1,
    title: 'Avinash Rao appointed as MD & CEO of Mahindra Susten',
    image: 'https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHw0fHxzb2xhciUyMGZhcm18ZW58MHx8fHwxNzg0MDA2NTcxfDA&ixlib=rb-4.1.0&q=85',
    date: 'Nov 2025',
  },
  {
    id: 2,
    title: 'Mahindra Susten Commissions 560 MWp Solar Power Projects in CY 2025, Reinforcing Leadership in Utility-Scale Renewable Energy',
    image: 'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxzb2xhciUyMGZhcm18ZW58MHx8fHwxNzg0MDA2NTcxfDA&ixlib=rb-4.1.0&q=85',
    date: 'Dec 2025',
  },
  {
    id: 3,
    title: 'The CEO Perspective That Matters: Avinash Rao Reveals the Optics Behind Effective Leadership',
    image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxzb2xhciUyMGZhcm18ZW58MHx8fHwxNzg0MDA2NTcxfDA&ixlib=rb-4.1.0&q=85',
    date: 'Nov 2025',
  },
  {
    id: 4,
    title: 'Mahindra Susten Wins Best Renewable Energy Developer Award 2025',
    image: 'https://images.unsplash.com/photo-1558449028-b53a39d100fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxzb2xhciUyMGZhcm18ZW58MHx8fHwxNzg0MDA2NTcxfDA&ixlib=rb-4.1.0&q=85',
    date: 'Oct 2025',
  },
  {
    id: 5,
    title: 'Susten Signs 300 MW Solar Project with GUVNL',
    image: 'https://images.unsplash.com/photo-1594818379496-da1e345b0ded?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVscyUyMGFlcmlhbHxlbnwwfHx8fDE3ODQwMDY1NjR8MA&ixlib=rb-4.1.0&q=85',
    date: 'Sep 2025',
  },
];

export const NEWS_MEDIA = [
  {
    id: 1,
    title: 'Susten PHC: Bridging the Healthcare Gap',
    image: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxyZW5ld2FibGUlMjBlbmVyZ3l8ZW58MHx8fHwxNzg0MDA2NTcxfDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 2,
    title: 'Transforming Education in Rural India: Susten School Developed Under Gyandeep',
    image: 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHx3aW5kJTIwdHVyYmluZXMlMjByZW5ld2FibGV8ZW58MHx8fHwxNzg0MDA2NTY1fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 3,
    title: 'Capturing the STEAM Lab Development Initiatives for Social Impact',
    image: 'https://images.unsplash.com/photo-1562519990-50eb51e282b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHx3aW5kJTIwdHVyYmluZXMlMjByZW5ld2FibGV8ZW58MHx8fHwxNzg0MDA2NTY1fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 4,
    title: 'Community Water Conservation Initiative Launched Across 5 States',
    image: 'https://images.unsplash.com/photo-1548337138-e87d889cc369?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHx3aW5kJTIwdHVyYmluZXMlMjByZW5ld2FibGV8ZW58MHx8fHwxNzg0MDA2NTY1fDA&ixlib=rb-4.1.0&q=85',
  },
];

export const COMMUNITY_CONNECT = [
  {
    id: 1,
    title: "Susten's Centre of Excellence Featured in UNGC",
    image: 'https://images.unsplash.com/photo-1726866492047-7f9516558c6e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxzb2xhciUyMHBhbmVscyUyMGFlcmlhbHxlbnwwfHx8fDE3ODQwMDY1NjR8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 2,
    title: 'Modhera Solar Project: A Landmark in Green Energy Innovation',
    image: 'https://images.unsplash.com/photo-1726776230760-ae81dc9d4e55?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxzb2xhciUyMHBhbmVscyUyMGFlcmlhbHxlbnwwfHx8fDE3ODQwMDY1NjR8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 3,
    title: 'Revolutionizing Solar Energy: Using Robotics to Conserve Water',
    image: 'https://images.unsplash.com/photo-1508791290064-c27cc1ef7a9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHx3aW5kJTIwdHVyYmluZXMlMjByZW5ld2FibGV8ZW58MHx8fHwxNzg0MDA2NTY1fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 4,
    title: 'Empowering Rural Women Through Solar Skill Training',
    image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxzb2xhciUyMGZhcm18ZW58MHx8fHwxNzg0MDA2NTcxfDA&ixlib=rb-4.1.0&q=85',
  },
];

export const TECH_VIDEOS = [
  {
    id: 1,
    title: 'Solar Farms of Tomorrow: Robotic Cleaning Systems',
    thumbnail: 'https://images.unsplash.com/photo-1594818379496-da1e345b0ded?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVscyUyMGFlcmlhbHxlbnwwfHx8fDE3ODQwMDY1NjR8MA&ixlib=rb-4.1.0&q=85',
    youtubeId: 'dQw4w9WgXcQ',
  },
  {
    id: 2,
    title: 'Powering India: The Rewa Story',
    thumbnail: 'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxzb2xhciUyMGZhcm18ZW58MHx8fHwxNzg0MDA2NTcxfDA&ixlib=rb-4.1.0&q=85',
    youtubeId: 'BHACKCNDMW8',
  },
  {
    id: 3,
    title: 'Innovations in Battery Energy Storage Systems',
    thumbnail: 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHx3aW5kJTIwdHVyYmluZXMlMjByZW5ld2FibGV8ZW58MHx8fHwxNzg0MDA2NTY1fDA&ixlib=rb-4.1.0&q=85',
    youtubeId: 'M7lc1UVf-VE',
  },
];

export const HERO_SLIDES = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHx3aW5kJTIwdHVyYmluZXMlMjByZW5ld2FibGV8ZW58MHx8fHwxNzg0MDA2NTY1fDA&ixlib=rb-4.1.0&q=85',
    tag: 'GREEN ENERGY',
    title: 'Decarbonizing the World',
    subtitle: 'Leading the charge towards a carbon-neutral tomorrow through renewable energy',
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxzb2xhciUyMGZhcm18ZW58MHx8fHwxNzg0MDA2NTcxfDA&ixlib=rb-4.1.0&q=85',
    tag: 'SOLAR POWER',
    title: 'Powering India\u2019s Green Future',
    subtitle: '1.5 GWp+ of solar assets across India delivering clean energy',
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1594818379496-da1e345b0ded?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVscyUyMGFlcmlhbHxlbnwwfHx8fDE3ODQwMDY1NjR8MA&ixlib=rb-4.1.0&q=85',
    tag: 'INNOVATION',
    title: 'Innovating for a Sustainable World',
    subtitle: 'Pioneering solutions in solar, wind, hybrid and battery storage',
  },
];
